import React from "react";
import { Icon } from "../../components/Component";
import { Link } from "react-router-dom";

const WorkRequestAside = ({ updateSm, sm }: any) => {
  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">Work Request</span>
            <span className="sub-text">Request and track work activities</span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-request-creation`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-round-fill" />
              <span>New Work Request</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-request-list`}
              onClick={() => updateSm(false)}
            >
              <Icon name="list-fill" />
              <span>View Work Request List</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-request-approvals`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-circle-fill" />
              <span>Work Request Approvals</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-request-reports`}
              onClick={() => updateSm(false)}
            >
              <Icon name="reports" />
              <span>Work Request Reports</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default WorkRequestAside;